// TODO: decompose into something like selectors/*group*.js w/ index

export const clientIdSelector = (state) => state.client.client.id;
